
export function authentication(payload) {
    return {
        type: 'AUTH',
        payload: payload
    }
}

export function logoff() {
    return {
        type: 'LOGOFF',
        value: true
    }
}